export const form = {
  email: {
    label: 'Email',
    placeholder: 'Enter your email address'
  },
  name: {
    label: 'First name',
    placeholder: 'Enter your first name'
  },
  clubName: {
    label: 'Club name',
    placeholder: 'Enter the club name',
    description: 'Enter the name using Latin characters'
  },
  address: {
    label: 'Address',
    placeholder: 'Enter the address'
  },
  workPeriod: {
    start: {
      placeholder: 'Work start date'
    },
    end: {
      placeholder: 'Work end date'
    }
  },
  workTime: {
    start: {
      label: 'Opening time'
    },
    end: {
      label: 'Closing time'
    }
  },
  country: {
    label: 'Specify the club location',
    placeholder: 'Specify the club location'
  },
  role: {
    label: 'Club vacancies'
  },
  currency: {
    label: 'Specify the currency used for artist payments',
    placeholder: 'Specify the currency used for artist payments'
  },
  nativeLanguage: {
    label: 'Native language',
    placeholder: 'Specify your native language'
  },
  lastName: {
    label: 'Last name',
    placeholder: 'Enter your last name'
  },
  birth: {
    label: 'Date of birth',
    placeholder: 'Enter your date of birth'
  },
  password: {
    label: 'Password',
    placeholder: 'Enter password',
    description:
      'The password must contain at least 8 characters, including uppercase and lowercase letters, digits, and special characters (e.g. !, @, #, $).'
  },
  resetPassword: {
    new: {
      label: 'New password',
      placeholder: 'Enter new password'
    },
    confirm: {
      label: 'Confirm password',
      placeholder: 'Enter new password'
    }
  },
  penalties: {
    placeholder: 'Enter a penalty name'
  },
  phone: {
    label: 'Phone number',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Continue',
    login: 'Log in',
    send: 'Send',
    cancel: 'Cancel',
    confirm: 'Confirm',
    resend: 'Send again',
    register: 'Register',
    registerRequest: 'Submit registration request'
  },
  links: {
    forgotPasswordLink: 'Forgot password?',
    login: 'Log in',
    haveAccount: 'I already have an account',
    privacy: 'User Agreement and Privacy Policy.'
  },
  other: {
    or: 'Or'
  },
  approximateStartDate: { label: 'Estimated start date' },
  approximateEndDate: { label: 'Estimated end date' },
  search: {
    placeholder: 'Search',
    placeholderCitizienship: 'Search by citizenship'
  },
  positionItem: {
    label: 'Enter a role'
  },
  paymentFrequency: {
    label: 'Payment frequency'
  },
  price: {
    label: 'Price'
  },
  priceForArtist: {
    label: 'Amount for the artist'
  },
  artistPercent: {
    label: 'Percentage for the artist'
  }
};
